import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

export const CustomMenuItem = withStyles(theme => ({
	root: {
		padding: theme.spacing(2.5),
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(5)
	}
}))(MenuItem);

export const CustomListItemIcon = withStyles(theme => ({
	root: {
		minWidth: 30
	}
}))(ListItemIcon);
